import React from "react";
import "../styles/Main.css";

const Main = ({ className, children }) => (
  <div className={`main ${className || ""}`}>{children}</div>
);

export default Main;

